
import QueryStringUtil from 'utils/QueryStringUtil';

// translation layer for the ASP.NET MVC Model shoved into the window
const model = window.model.BriefViewModel;

export default class DSBriefModel {
    static get templates() {
        return model.TemplatesJson ? JSON.parse(model.TemplatesJson) : null;
    }

    static get altDocId() {
        return model.DocumentId;
    }

    static get coDesignIsEnabled() {
        return model.CoDesignEnabled && !this.isHolidayUG;
    }

    static get designLivePreSelected() {
        return model.DesignLivePreSelected !== null ? model.DesignLivePreSelected : false;
    }
    
    static get isReadOnly() {
        return model.IsReadOnly;
    }

    static get isEditFromCart() {
        return model.IsEditFromCart;
    }

    static get isCoDesign() {
        return model.IsCoDesign;
    }

    static get socialMediaDesignEnabled() {
        return model.SocialMediaDesignEnabled;
    }
    
    static get socialMediaDesignsRequested() {
        return model.SocialMediaDesignsRequested;
    }

    static get merchantItemId() {
        if (model.Order != null) {
            return model.Order.MerchantItemId;
        }     
        return null;
    }

    static get preSelectedProductName() {
        return model.PreSelectedProductName;
    }

    static get preSelectedProductPfid() {
        return model.PreSelectedPfid;
    }

    static get localizedBasePriceHTML() {
        return model.LocalizedPriceHtml;
    }

    static get localizedDesignLivePriceIncreaseHTML() {
        return model.LocalizedDesignLivePriceIncreaseHtml;
    } 

   static get note() {
        return model.Note !== null ? model.Note : '';
    }
    
    static get templatesNum() {       
        if (this.templates !== null) {
            return this.templates.length;
        }
        return model.TemplatesNumber !== undefined ? model.TemplatesNumber : 0;
    }
    
    static get uploads() {
        return model.UploadIds !== null ? model.UploadIds : [];
    }

    static get uploadRefs() {
        return model.UploadRefs !== null ? model.UploadRefs : [];
    }

    static get preSelectedProduct() {
        if (!this.preSelectedProductName || !this.preSelectedProductPfid) {
            return null;
        }
        
        return {
            name: this.preSelectedProductName,
            pfid: this.preSelectedProductPfid,
            priceHTML: this.preSelectedProductPriceHTML,
            priceMultiplier: this.preSelectedProductPriceMultiplier,
            productGroup: this.preSelectedProductGroupName
        };
    }

    static get productsByCategory() {
        return model.ProductGroups.map(productCategory => ({
            name: productCategory.Name,
            products: productCategory.ProductSelections.map(product => ({
                name: product.Name,
                pfid: product.Pfid,
                priceMultiplier: product.DifyServiceQty,
                productGroup: product.ProductGroup,
                priceHTML: product.DifyDisplayPrice,
            })),
        }));
    }

    static get preSelectedProductPriceHTML() {
        return model.PreSelectedDifyPrice;
    }

    static get preSelectedProductPriceMultiplier() {
        return model.PreSelectedDifyQty;
    }
    
    static get preSelectedProductGroupName() {
        return model.PreSelectedProductGroupName;
    }

    static get previousDesigners() {
        return model.PreviousDesigners;
    }

    // todo: this will likely only work for english - we'll need to investigate a service to get better names when we localize #localization
    static _parseProductConfigName(productConfigName) {
        try {
            let displayName = productConfigName;

            // some product config names start with a string of uppercase letters (e.g. BCPaperStocks); remove those
            const suspectedFirstLetterMatch = /[A-Z](?=[a-z])/.exec(productConfigName);
            if (suspectedFirstLetterMatch !== null) {
                displayName = productConfigName.slice(suspectedFirstLetterMatch.index);
            }
    
            // un-camelcase by splitting before uppercase letters and joining with spaces
            // handles strings that already have spaces by trimming before joining with spaces
            // finally ensure that the first letter is capitalized by replacing the first character with the uppercase version
            return displayName.split(/(?=[A-Z])/).map(word => word.trim()).join(' ').replace(/^\w/, c => c.toUpperCase());
        } catch (error) {
            // if something goes horribly wrong, just return the original name
            // todo: log failure?
            return productConfigName;
        }
    }

    static get preSelectedProductConfig() {
        return model.PreSelectedProductConfig.map(config => ({
            id: config.Id,
            key: config.Key,
            name: config.Name,
            displayName: DSBriefModel._parseProductConfigName(config.Name),
            value: config.Value,
        }));
    }

    static get isHolidayUG () {
        return (QueryStringUtil.getValueByKey("hhug") || "").toLowerCase() === "true"
            && model.HolidayUGEnabled
            && this.templatesNum > 0;
    }
}



// WEBPACK FOOTER //
// ./src/models/DSBriefModel.js